import React, {useEffect} from "react";
import {Grid} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {CategoryModel} from "../../../models/category.model";
import {loadCategories, loadCsvCategories} from "../../../store/categories/categories-slice";
import {RootState} from "../../../store/root-reducer";
import {CategoriesPicker} from "./categories-picker";
import {CategoriesFillData} from "./categories-fill-data";
import {toggleLoader} from "../../../store/global/global-slice";
import {useTranslation} from "react-i18next";

export const PublisherCreateProfile: React.FC<{handleProfileData: Function, initProfile?: {}, extendErrorDetails?: boolean}> = ({handleProfileData, initProfile, extendErrorDetails = false}) => {
    const [categoriesSelected, setCategoriesSelected] = React.useState<CategoryModel[]>([]);
    const [totalBooks, setTotalBooks] = React.useState(0);
    const [categoriesCalculated, setCategoriesCalculated] = React.useState<CategoryModel[]>([]);
    const { t } = useTranslation(['publisher', 'common']);
    const [totalBooksError, setTotalBooksError] = React.useState<boolean>(false);

    useEffect(() => {
        handleProfileData(getProfileData());
        // eslint-disable-next-line
    },[categoriesCalculated, totalBooks]);

    const getProfileData = (): IProfileData => {
        setTotalBooksError(false);
        let valid = true;
        let totalMainCategory = 0;
        let errorText = '';

        if (!totalBooks) {
            valid = false;
            setTotalBooksError(true);
            errorText = t('createPublisherProfile.totalBooksError');
        } else if (totalBooks < 0) {
            valid = false;
            setTotalBooksError(true);
            errorText = t('createPublisherProfile.totalBooksMinusError');
        }

        categoriesCalculated.forEach(mainCategory => {
            totalMainCategory = totalMainCategory + mainCategory.count;
            if (mainCategory.children?.length > 0 && mainCategory.totalChildrenCount < 99.5) {
                valid = false;
                errorText = t('createPublisherProfile.categoriesTotalError');
            }
            if (mainCategory.count < 0) {
                valid = false;
                errorText = t('createPublisherProfile.categoriesMinusError');
            }
        });

        if (totalMainCategory !== 100) {
            valid = false;
            errorText = t('createPublisherProfile.categoriesTotalError');
        }

        if (categoriesCalculated.length === 0) {
            valid = false;
            errorText = t('createPublisherProfile.categoriesEmptyError');
        }

        return {
            totalBooks: totalBooks,
            categoriesCalculated: categoriesCalculated,
            valid: valid,
            errorText: errorText
        };
    }

    const themaCategories: CategoryModel[] = useSelector(
        (state: RootState) => state.categories.categories
    );

    return (
        <Grid container direction={"column"}>
            <Grid container direction={'row'} spacing={2}>
                <Grid item xs>
                    {themaCategories && themaCategories.length > 0 &&
                        <CategoriesPicker
                            handleSelectedCategory={(categories) => {setCategoriesSelected(categories);}}
                            initProfile={initProfile}
                        />
                    }
                </Grid>

                <Grid item xs>
                    <CategoriesFillData
                        totalBooksError={totalBooksError}
                        categoriesSelected={categoriesSelected}
                        returnNewCategories={(categories) => {setCategoriesCalculated(categories)}}
                        returnTotalBooks={(total) => {setTotalBooks(total)}}
                        initTotal={(initProfile) ? initProfile['TOTAL'] : 0}
                        extendErrorDetails={extendErrorDetails}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export interface IProfileData {
    totalBooks: number;
    categoriesCalculated: CategoryModel[];
    valid: boolean;
    errorText: string;
}
